import { SwitchLabelUi as SwitchLabel } from "./SwitchLabel.ui"

export default SwitchLabel
